import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  UpdateInvoiceDeliveryDateActions as Actions,
  UpdateInvoiceDeliveryDateRequestAction as RequestAction,
} from 'store/ducks/pendingRelease/updateInvoiceDeliveryDate';

export function* updateInvoiceDeliveryDateRequest(action: any) {
  const { payload, onSuccess, onFailure }: RequestAction = action;
  try {
    const { data } = yield call(api.post, `invoices/deliveryDate`, payload);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
